/**
 * Роли приложения — зеркало `PlatformAccessSetup.Roles` (Platform.Infrastructure).
 * Список нужен сам по себе, а не из матрицы: пакет Kalmykov Access отдаёт в
 * матрице только роли, которым что-то выдано, и роль без прав пропала бы с
 * экрана вместе с возможностью выдать их обратно.
 */
export const PLATFORM_ROLES = [
  { value: 'system_admin', label: 'Администратор приложения' },
  { value: 'supplier', label: 'Поставщик' },
  { value: 'accountant', label: 'Бухгалтер' },
  { value: 'seller', label: 'Продавец' },
] as const

/** Суперроль: весь каталог мимо матрицы и допуска к ресурсам (RP-A3). */
export const SUPER_ROLE = 'system_admin'

export const DEFAULT_ROLE = 'seller'

export function roleTitle(role: string): string {
  return PLATFORM_ROLES.find((item) => item.value === role)?.label ?? role
}

/** Ключ матрицы права вида: `onec` + `diagnostics.read` → `onec:diagnostics:read` (`AccessKeys.ForResource`). */
export function resourcePermissionKey(kind: string, capability: string): string {
  return `${kind}:${capability.replaceAll('.', ':')}`
}

/** Префикс ключей собственных прав Platform: `platform:registry:read`. Вида ресурса с таким именем быть не может. */
export const PLATFORM_GROUP = 'platform'

/**
 * Права самой Platform словами — тот же текст, которым их подписывает сервер (`PlatformAccessSetup.Seed`).
 * Нужны панели «Мои роли и права»: каталог целиком получает только администратор, остальным ключ был бы голым кодом.
 */
export const PLATFORM_KEY_TITLES: Readonly<Record<string, string>> = {
  'platform:registry:read': 'Реестр ресурсов: просмотр',
  'platform:registry:write': 'Реестр ресурсов: создание и правка',
  'platform:sync:read': 'Синхронизация: просмотр',
  'platform:sync:write': 'Синхронизация: настройка правил и запусков',
  'platform:schedule:view': 'График выхода: просмотр',
  'platform:schedule:manage': 'График выхода: правка смен, видов смен и состава',
  'platform:search:test': 'Поиск по фото: тестовый каталог замеров',
  'platform:testing:search': 'Тестирование: замеры поиска по фото',
}

/** Группа и право вида из ключа матрицы: `onec:diagnostics:read` → `onec` и `diagnostics.read`. Ключ без «:» — в группу «other». */
export function splitPermissionKey(key: string): { group: string; capability: string } {
  const at = key.indexOf(':')
  if (at <= 0) return { group: 'other', capability: key }
  return { group: key.slice(0, at), capability: key.slice(at + 1).replaceAll(':', '.') }
}
